'use client';

import { useState } from 'react';
import { sva } from '@bts-web/utils-style-engine';
import { SortOrder } from '@bts-web/data-layer/server';
import { FilledArrowSortDown, FilledArrowSortUp } from '../../svgIcons';

const sortButtonStyles = sva({
  slots: ['root', 'icon'],
  base: {
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      minHeight: '40px',
      minWidth: '40px',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  variants: {
    visual: {
      primary: {
        root: {
          color: 'neutrals.text_primary',
          backgroundColor: 'neutrals.fill_quaternary',
          borderRadius: '30px',
          width: '40px',
          height: '40px',
          padding: 'extra_small_2',
          '&:disabled': {
            backgroundColor: 'neutrals.fill_quinary',
            opacity: '0.5',
          },
        },
      },
    },
  },
  defaultVariants: {
    visual: 'primary',
  },
});

type SortButtonStylesVariantProps = Parameters<typeof sortButtonStyles>[0];

type SortButtonProps = SortButtonStylesVariantProps & {
  disabled?: boolean;
  defaultValue?: SortOrder;
  onChange: (order: SortOrder) => void;
};

export const SortButton = ({
  visual = 'primary',
  defaultValue = 'DESC',
  disabled,
  onChange,
}: SortButtonProps) => {
  const [sortValue, setSortValue] = useState<SortOrder>(defaultValue);

  const handleClick = () => {
    const newSortValue = sortValue === 'DESC' ? 'ASC' : 'DESC';

    setSortValue(newSortValue);

    onChange(newSortValue);
  };

  const styles = sortButtonStyles({ visual });

  return (
    <button
      data-state={sortValue.toLowerCase()}
      data-testid="sort-button"
      onClick={handleClick}
      disabled={disabled}
      className={styles.root ?? ''}
    >
      {sortValue === 'ASC' ? (
        <FilledArrowSortUp size={24} />
      ) : (
        <FilledArrowSortDown size={24} />
      )}
    </button>
  );
};
